export const BOOKING_ANALYTICS = {id: 'BK_AN', label: 'Booking Analytics'};
